import { render, staticRenderFns } from "./SelectShelfTypeComponent.vue?vue&type=template&id=33cda4aa&scoped=true"
import script from "./SelectShelfTypeComponent.vue?vue&type=script&lang=js"
export * from "./SelectShelfTypeComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectShelfTypeComponent.vue?vue&type=style&index=0&id=33cda4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cda4aa",
  null
  
)

export default component.exports